export function getMapboxAccessToken() {
  return 'pk.eyJ1IjoiY29kZW9yZyIsImEiOiJjanlnOWZqejIwMHVvM2xxcGMyY25wMzYzIn0.WyPOM-uIk6djBffSPg9gNA';
}
